import { getStoredCurrLocation } from '@m2h/common/utils/location';

const machProEnvMap = {
  test: 'Test',
};

const HK_LOCATION = {
  latitude: '22.3203648',
  longitude: '114.169773',
};

// 地球半径（公里）
// const EARTH_RADIUS = 6371;
// 距离（公里）
const EAST_WEST_DISTANCE = 5000; // 东西各5000公里
const NORTH_SOUTH_DISTANCE = 3000; // 南北各3000公里
// 计算纬度变化（1度纬度约等于111公里）
const latitudeDelta = NORTH_SOUTH_DISTANCE / 111;
const DEFAULT_SIDES = {
  north: 90, // 北边界，限制在90度以内
  south: -90, // 南边界，限制在-90度以上
  east: 180, // 东边界，覆盖全球
  west: -180, // 西边界，覆盖全球
};

const module = {
  getLimitBounds() {
    const currentLocation = getStoredCurrLocation();

    let { latitude, longitude } = currentLocation;
    latitude = +latitude;
    longitude = +longitude;
    if (
      !currentLocation
      || typeof latitude !== 'number'
      || typeof longitude !== 'number'
      || isNaN(latitude)
      || isNaN(longitude)
    ) {
      return {
        NorthEastLat: DEFAULT_SIDES.north,
        NorthEastLng: DEFAULT_SIDES.east,
        SouthWestLat: DEFAULT_SIDES.south,
        SouthWestLng: DEFAULT_SIDES.west,
        ...DEFAULT_SIDES,
        center: {
          latitude,
          longitude
        }
      };
    }

    // 计算经度变化（经度变化需要考虑纬度的影响）
    const longitudeDelta = EAST_WEST_DISTANCE / (111 * Math.cos(latitude * Math.PI / 180));

    const side = {
      north: Math.min(latitude + latitudeDelta, 90), // 北边界，限制在90度以内
      south: Math.max(latitude - latitudeDelta, -90), // 南边界，限制在-90度以上
      east: longitude + longitudeDelta, // 东边界
      west: longitude - longitudeDelta, // 西边界
    };
    // 计算边界
    return {
      NorthEastLat: side.north,
      NorthEastLng: side.east,
      SouthWestLat: side.south,
      SouthWestLng: side.west,
      ...side,
      center: {
        latitude,
        longitude
      }
    };
  },
  getLimitBoundsWithRegion() {
    return {};
  },
};

export default module;
